"use strict";
// --------------------------------------------------------------------------------------------------------------------
// <copyright file="MeetingHeader.ts" company="Microsoft">
//   Copyright (c) Microsoft Corporation.  All rights reserved.
// </copyright>
// <summary>
//   TypeScript implementation of the HxMeetingHeader object
//   THIS FILE IS GENERATED BY A TOOL -- OBJECTGEN, DO NOT EDIT BY HAND
// </summary>
// --------------------------------------------------------------------------------------------------------------------
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HxMeetingHeader = void 0;
var HxObject_1 = __importDefault(require("./HxObject"));
var HxObjectID_1 = __importDefault(require("./HxObjectID"));
var HxObjectType_1 = __importDefault(require("./HxObjectType"));
var HxDailyPattern_1 = require("./HxDailyPattern");
var HxEndDatePatternRange_1 = require("./HxEndDatePatternRange");
var HxMonthlyAbsolutePattern_1 = require("./HxMonthlyAbsolutePattern");
var HxMonthlyRelativePattern_1 = require("./HxMonthlyRelativePattern");
var HxNoEndPatternRange_1 = require("./HxNoEndPatternRange");
var HxNumberedPatternRange_1 = require("./HxNumberedPatternRange");
var HxWeeklyPattern_1 = require("./HxWeeklyPattern");
var HxYearlyAbsolutePattern_1 = require("./HxYearlyAbsolutePattern");
var HxYearlyRelativePattern_1 = require("./HxYearlyRelativePattern");
var HxMeetingHeader = /** @class */ (function (_super) {
    __extends(HxMeetingHeader, _super);
    function HxMeetingHeader(objectId, storageSequenceNumber, obj, activeSet) {
        var _this = _super.call(this, objectId, HxObjectType_1.default.HxMeetingHeader, storageSequenceNumber, activeSet) || this;
        _this.update(obj);
        return _this;
    }
    HxMeetingHeader.prototype.update = function (obj) {
        var e_1, _a;
        try {
            for (var _b = __values(Object.entries(obj)), _c = _b.next(); !_c.done; _c = _b.next()) {
                var _d = __read(_c.value, 2), key = _d[0], v = _d[1];
                switch (key) {
                    case '1':
                        this.objectId = new HxObjectID_1.default(v);
                        break;
                    case '2':
                        this.parentId = new HxObjectID_1.default(v);
                        break;
                    case '1283':
                        this.accountHandle = v;
                        break;
                    case '104A':
                        this.calendarItemReferenceId = v;
                        break;
                    case 'DC4':
                        this.canRSVP = v;
                        break;
                    case '10DA':
                        this.disallowNewTimeProposal = v;
                        break;
                    case 'B5C':
                        this.end = new Date(v);
                        break;
                    case 'EF0':
                        this.hasGroupEventBeenAddedToCalendar = v;
                        break;
                    case 'FBE':
                        this.hasNewProposedTime = v;
                        break;
                    case 'B5D':
                        this.isAllDay = v;
                        break;
                    case 'DE5':
                        this.isCancelled = v;
                        break;
                    case 'B5E':
                        this.isDelegated = v;
                        break;
                    case 'DC9':
                        this.isOrganizer = v;
                        break;
                    case 'B5F':
                        this.isRecurring = v;
                        break;
                    case 'B60':
                        this.isResponseRequested = v;
                        break;
                    case 'FBF':
                        this.proposedEndTime = new Date(v);
                        break;
                    case 'FC0':
                        this.proposedStartTime = new Date(v);
                        break;
                    case 'B61':
                        this.receivedFor = v;
                        break;
                    case 'BC4':
                        this.repeatSeriesData_DailyPattern = HxDailyPattern_1.deserializeHxDailyPattern(v);
                        break;
                    case 'BC5':
                        this.repeatSeriesData_EndDatePatternRange = HxEndDatePatternRange_1.deserializeHxEndDatePatternRange(v);
                        break;
                    case 'BC6':
                        this.repeatSeriesData_MonthlyAbsolutePattern = HxMonthlyAbsolutePattern_1.deserializeHxMonthlyAbsolutePattern(v);
                        break;
                    case 'BC7':
                        this.repeatSeriesData_MonthlyRelativePattern = HxMonthlyRelativePattern_1.deserializeHxMonthlyRelativePattern(v);
                        break;
                    case 'BC8':
                        this.repeatSeriesData_NoEndPatternRange = HxNoEndPatternRange_1.deserializeHxNoEndPatternRange(v);
                        break;
                    case 'BC9':
                        this.repeatSeriesData_NumberedPatternRange = HxNumberedPatternRange_1.deserializeHxNumberedPatternRange(v);
                        break;
                    case 'BCA':
                        this.repeatSeriesData_Pattern = v;
                        break;
                    case 'BCB':
                        this.repeatSeriesData_PatternRange = v;
                        break;
                    case 'BCC':
                        this.repeatSeriesData_WeeklyPattern = HxWeeklyPattern_1.deserializeHxWeeklyPattern(v);
                        break;
                    case 'BCD':
                        this.repeatSeriesData_YearlyAbsolutePattern = HxYearlyAbsolutePattern_1.deserializeHxYearlyAbsolutePattern(v);
                        break;
                    case 'BCE':
                        this.repeatSeriesData_YearlyRelativePattern = HxYearlyRelativePattern_1.deserializeHxYearlyRelativePattern(v);
                        break;
                    case 'B63':
                        this.requestType = v;
                        break;
                    case 'DE7':
                        this.responseType = v;
                        break;
                    case '12CF':
                        this.sharedCalendarId = v;
                        break;
                    case '12D0':
                        this.sharedCalendarItemId = v;
                        break;
                    case 'B64':
                        this.start = new Date(v);
                        break;
                    case 'B65':
                        this.startTimeZoneId = v;
                        break;
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
    };
    HxMeetingHeader.prototype.getAccount = function (sessionId) {
        return this.activeSet.getObjectFromHandle(this.accountHandle, HxObjectType_1.default.HxAccount, sessionId).then(function (result) { return result; });
    };
    return HxMeetingHeader;
}(HxObject_1.default));
exports.HxMeetingHeader = HxMeetingHeader;
exports.default = HxMeetingHeader;
